import './MainPage.module.scss'
import styles  from './MainPage.module.scss'
import mainBg from 'assets/images/hero.png'
import mainBgS from 'assets/images/main-bg-s.png'
import {userLang} from 'components/utils'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

const tmp = {
    ru: /*html*/`
        <h1 data-title="Мировое большинство">Мировое большинство</h1>
        <p>Международный межпартийный Форум в формате «БРИКС и страны-партнеры»</p>
        <h1 data-title="за многополярный мир">за многополярный мир</h1>
        <div>
            16–19 июня 2024 <br> Владивосток
        </div>
    `,
    en : /*html*/`
        <h1 data-title="World Majority">World Majority</h1>
        <p>International Inter-Party Forum «BRICS and Partner-Countries»</p>
        <h1 data-title="for a Multipolar World">for a Multipolar World</h1>
        <div>
            June 16–19, 2024 <br> Vladivostok
        </div>
    `,
    es : /*html*/`
        <h1 data-title="Mayoría Mundial">Mayoría Mundial</h1>
        <p>Foro International Entre Partidos «BRICS y Países Socios»</p>
        <h1 data-title="por un Mundo Multipolar">por un Mundo Multipolar</h1>
        <div>
            16 al 19 de junio de 2024 <br> Vladivostok
        </div>
    `,
    fr : /*html*/`
        <h1 data-title="Majorité Mondiale">Majorité Mondiale </h1>
        <p>Forum International Interpartis «BRICS et Pays Partenaires»</p>
        <h1 data-title="pour un Monde Multipolaire">pour un Monde Multipolaire</h1>
        <div>
            16-19 juin 2024 <br> Vladivostok
        </div>
    `
}

export const MainPage = () => {
    const [content, setContent] = useState(tmp[userLang().split('-')[0] || userLang()])
    const { i18n } = useTranslation()
    
    useEffect(()=> {
        setContent(tmp[i18n.language.split('-')[0] || i18n.language])
    }, [i18n, i18n.language, setContent])

    return (
        <section className={styles.main}>
            <div className="container">
                <div className={styles.bg}>
                    <picture>
                        <source srcSet={mainBgS} width={768} height={768} media="(max-width: 768px)" />
                        <img src={mainBg} alt="" width={1920} height={720}/>
                    </picture>
                </div>
                <div className={styles.content} dangerouslySetInnerHTML={{ __html: content}} />
                {/* <div className={styles.content}>
                    <div className={styles.content_box}>
                        <h1 className={styles.title}>
                            {t('description')}
                            <strong>«{t('title')}»</strong>
                        </h1>

                        <div className={styles.buttons}>
                            <button className={['btn', styles.btn].join(' ')} onClick={triggerRegModal}>
                                {t('register')}
                            </button>
                            <button className={['btn btn_empty', styles.btn].join(' ')} onClick={loginHandler}>
                                {t('login')}
                            </button>
                        </div>

                    </div>
                </div> */}
            </div>
        </section>
    )
}
